// extracted by mini-css-extract-plugin
module.exports = {"btn_add":"create-client-dropdown-btn_add__21-Vr"};